import {ReactElement} from "react";

interface ImageGridProps {
    images: string[]
    selected: string | null
    onSelect: (image: string) => void
}

export function ImageGrid(props: ImageGridProps): ReactElement {
    return (
        <div className="w-full h-full grid grid grid-cols-3 gap-12 items-end justify-center
                        xl:grid-cols-4">
            {props.images.map(i => (
                <button
                    key={i}
                    onClick={() => props.onSelect(i)}
                    className={`outline rounded-lg overflow-hidden
                                ${i === props.selected ? 'outline-2 outline-primary' : 'outline-1 outline-gray-2'}`}>
                    <img src={i}
                         alt="cover option"
                         className="w-full h-auto object-contain"
                    />
                </button>
            ))}
        </div>
    );
}